export var FEATURE_FLAGS;
(function (FEATURE_FLAGS) {
    FEATURE_FLAGS["ENABLE_E_CHARTS"] = "ENABLE_E_CHARTS";
    FEATURE_FLAGS["ENABLE_SYMBOL_LIBRARY"] = "ENABLE_SYMBOL_LIBRARY";
})(FEATURE_FLAGS || (FEATURE_FLAGS = {}));
